import { useQuery } from '@tanstack/react-query'
import { fetchInterventions } from '../services/care_plan';

const GetInterventions = () => {
 const getInterventions = useQuery({
    queryKey:['interventions'],
    queryFn: fetchInterventions
 })
 return getInterventions;
}

export default GetInterventions